import PropTypes from 'prop-types';

const BillSummary = ({ totalNetAmount, totalGrossAmount }) => {
  const VAT = (Math.abs(totalGrossAmount) || 0) - (totalNetAmount || 0);
  return (
    <div className="ml-auto flex max-w-80 flex-col gap-2 text-lg">
      <div className="flex justify-between gap-8">
        <span>Subtotal (€):</span>
        <span className="font-semibold">{totalNetAmount && totalNetAmount.toFixed(2)}</span>

      </div>
      <div className="flex justify-between gap-8">
        <span>VAT:</span>
        <span
          className="font-semibold"
        >
          {VAT.toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between gap-8 text-2xl font-bold text-pj-primary-400">
        <span>Total (€):</span>
        <span>{totalGrossAmount && Math.abs(totalGrossAmount).toFixed(2)}</span>
      </div>
    </div>
  );
};

BillSummary.propTypes = {
  totalGrossAmount: PropTypes.number.isRequired,
  totalNetAmount: PropTypes.number.isRequired,
};

export default BillSummary;
